import { Box, Typography } from "@material-ui/core";
import EmptyInvestmentsImg from "../../assets/images/empty-investments.svg";
import useStyles from "../Styles/ShowProjectStyles";

export default function EmptyWallets() {
  const classes = useStyles();

  return (
    <Box
      my={3}
      display="flex"
      justifyContent={"center"}
      alignItems="center"
      flexDirection={"column"}
      textAlign="center"
    >
      <img src={EmptyInvestmentsImg} alt="Empty investments" style={{maxWidth:"90%"}} />
      <Typography className={classes.emptyTitle}>No investments</Typography>
      <Typography variant="body1" style={{ maxWidth: 365 }}>
        You haven’t add any wallets yet.
      </Typography>
      
    </Box>
  );
}
